import { Injectable } from '@angular/core';

import { ROUTING_PATH } from '@shared/constants/routingPath';

import {
  TrialInsightsSiteCostKey,
  TrialInsightsTableModel,
  TrialInsightsTableOptions,
  TrialInsightsTableRowData,
} from '../../models/trial-insights-table.model';

@Injectable({
  providedIn: 'root',
})
export class TrialInsightsClinicalSiteCostTableService implements TrialInsightsTableModel {
  route = ROUTING_PATH.INVESTIGATOR.INDEX;
  subRoute = `${ROUTING_PATH.INVESTIGATOR.SITE_COSTS.INDEX}/${ROUTING_PATH.INVESTIGATOR.SITE_COSTS.SITES.INDEX}`;

  createTable = (
    selectedKey: TrialInsightsSiteCostKey = TrialInsightsSiteCostKey.SPEND,
    rowData: TrialInsightsTableRowData[] = []
  ): TrialInsightsTableOptions => {
    return {
      buttons: {
        data: [
          { key: 'spend', value: 'Spend Per Site' },
          { key: 'lag', value: 'Lagging Data' },
        ],
        defaultButtonKey: selectedKey,
        display: true,
      },
      header: {
        data: [
          { buttonKey: 'spend', leftValue: 'Site', rightValue: 'Total Spend' },
          { buttonKey: 'lag', leftValue: 'Site', rightValue: 'Last Data' },
        ],
        display: true,
      },
      link: {
        display: true,
        url: `/${this.route}/${this.subRoute}`,
        value: 'See All Sites',
      },
      rowData: {
        compact: false,
        data: rowData,
      },
    };
  };
}
